// // import React, { useContext, useState } from 'react'
// // import './navbar.css'
// // import { Link } from 'react-router-dom';
// // import MegaMenu from "../Megamenu/MegaMenu";
// // import logo from '../Assets/Frontend_Assets/logo.png'
// // import cart_icon from '../Assets/Frontend_Assets/cart_icon.png'
// // import { ShopContext } from '../../Context/ShopContext';
// // export const Navbar = () => {
// //     const [menu , setMenu] = useState("shop");
// //     const {getTotalCartItems} = useContext(ShopContext);
// //     const [activeMega, setActiveMega] = useState(null);
// //   return (
// //     <div className='navbar'>
// //         <div className='nav-logo'>
// //             <img src={logo} alt="logo_img" />
// //             <p>khan Collections</p>
// //         </div>
// //         <ul className='nav-menu'>
// //            <li onClick={() => setMenu("shop")}>
// //           <Link to="/"  style={{textDecoration:'none'}}>Shop</Link> {menu === "shop" && <hr />}
// //         </li>
// //         <li onClick={() => setMenu("mens")}  onMouseEnter={() => setActiveMega("men")} onMouseLeave={() => setActiveMega(null)}>
// //          <Link to="/mens" style={{textDecoration:'none'}}>Men</Link>  <MegaMenu mainCategory="men" show={activeMega === "men"} /> {menu === "mens" && <hr />}
// //         </li>
// //         <li onClick={() => setMenu("womens")} onMouseEnter={() => setActiveMega("women")} onMouseLeave={() => setActiveMega(null)}>
// //           <Link to="/womens" style={{textDecoration:'none'}}>Women</Link> <MegaMenu mainCategory="women" show={activeMega === "women"} /> {menu === "womens" && <hr />}
// //         </li>
// //         <li onClick={() => setMenu("kids")}  onMouseEnter={() => setActiveMega("kids")} onMouseLeave={() => setActiveMega(null)}>
// //           <Link to="/kids" style={{textDecoration:'none'}}>Kids</Link> <MegaMenu mainCategory="kids" show={activeMega === "kids"} /> {menu === "kids" && <hr />}
// //         </li>
// //         </ul>
// //         <div className="nav-login-cart">
// //           {localStorage.getItem('auth-token')?<button onClick={()=>{localStorage.removeItem("auth-token");window.location.replace('/')}}>Logout</button>
// //           :<Link to="/Login" style={{textDecoration:'none'}}><button>Login</button></Link>}
            
// //             <Link to="/cart" style={{textDecoration:'none'}}><img src={cart_icon} alt="" /></Link>
// //             <div className="nav-cart-count">{getTotalCartItems()}</div>
// //             <Link to="/my-orders" style={{textDecoration:'none'}}><img src={cart_icon} alt="" /></Link>
           
// //         </div>
// //     </div>
// //   )
// // }
// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import "./navbar.css";
// import MegaMenu from "../Megamenu/MegaMenu";
// import logo from "../Assets/Frontend_Assets/logo.png";
// import cart_icon from "../Assets/Frontend_Assets/cart_icon.png";
// import { ShopContext } from "../../Context/ShopContext";
// import MyOrder from '../Assets/Frontend_Assets/myorder.png'
// export const Navbar = () => {
//   const { getTotalCartItems } = useContext(ShopContext);
//   const [menu, setMenu] = useState("shop");
//   const [activeMega, setActiveMega] = useState(null);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   return (
//     <nav className="navbar">
//       {/* Logo */}
//       <div className="nav-logo">
//         <img src={logo} alt="logo_img" />
//         <p>Khan Collections</p>
//       </div>

//       {/* Hamburger for Mobile */}
//       <div
//         className="mobile-hamburger"
//         onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//       >
//         <span></span>
//         <span></span>
//         <span></span>
//       </div>

//       {/* Menu */}
//       <ul className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
//         {/* Shop */}
//         <li
//           onClick={() => setMenu("shop")}
//           className={menu === "shop" ? "active" : ""}
//         >
//           <Link to="/" style={{ textDecoration: "none" }}>
//             Shop
//           </Link>
//           {menu === "shop" && <hr />}
//         </li>

//         {/* Men */}
//         <li
//           onClick={() => setMenu("mens")}
//           onMouseEnter={() => setActiveMega("men")}
//           // onMouseLeave={() => setActiveMega(null)}
//           className={menu === "mens" ? "active" : ""}
//         >
//           <div className="menu-wrapper">
//             <Link to="/mens" style={{ textDecoration: "none" }}>
//               Men
//             </Link>
//             <MegaMenu mainCategory="men" show={activeMega === "men"} />
//           </div>
//           {menu === "mens" && <hr />}
//         </li>

//         {/* Women */}
//         <li
//           onClick={() => setMenu("womens")}
//           onMouseEnter={() => setActiveMega("women")}
//           onMouseLeave={() => setActiveMega(null)}
//           className={menu === "womens" ? "active" : ""}
//         >
//           <div className="menu-wrapper">
//             <Link to="/womens" style={{ textDecoration: "none" }}>
//               Women
//             </Link>
//             <MegaMenu mainCategory="women" show={activeMega === "women"} />
//           </div>
//           {menu === "womens" && <hr />}
//         </li>

//         {/* Kids */}
//         <li
//           onClick={() => setMenu("kids")}
//           onMouseEnter={() => setActiveMega("kids")}
//           onMouseLeave={() => setActiveMega(null)}
//           className={menu === "kids" ? "active" : ""}
//         >
//           <div className="menu-wrapper">
//             <Link to="/kids" style={{ textDecoration: "none" }}>
//               Kids
//             </Link>
//             <MegaMenu mainCategory="kids" show={activeMega === "kids"} />
//           </div>
//           {menu === "kids" && <hr />}
//         </li>
//       </ul>

//       {/* Login / Cart */}
//       <div className="nav-login-cart">
//         {localStorage.getItem("auth-token") ? (
//           <button
//             onClick={() => {
//               localStorage.removeItem("auth-token");
//               window.location.replace("/");
//             }}
//           >
//             Logout
//           </button>
//         ) : (
//           <Link to="/Login" style={{ textDecoration: "none" }}>
//             <button>Login</button>
//           </Link>
//         )}

       

//         <Link to="/my-orders" style={{ textDecoration: "none" }}>
//          <img src={MyOrder} alt="orders"  style={{ width: "25px", height: "25px" }}/>

//         </Link>
//          <Link to="/cart" style={{ textDecoration: "none" }}>
//           <img src={cart_icon} alt="cart" style={{ width: "25px", height: "25px" }} />
//           <div className="nav-cart-count">{getTotalCartItems()}</div>
//         </Link>
//       </div>
//     </nav>
//   );
// };
// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import "./navbar.css";
// import MegaMenu from "../Megamenu/MegaMenu";
// import logo from "../Assets/Frontend_Assets/logo.png";
// import cart_icon from "../Assets/Frontend_Assets/cart_icon.png";
// import user_icon from "../Assets/Frontend_Assets/people.png"; 
// import { ShopContext } from "../../Context/ShopContext";

// export const Navbar = () => {
//   const { getTotalCartItems } = useContext(ShopContext);
//   const [menu, setMenu] = useState("shop");
//   const [activeMega, setActiveMega] = useState(null);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [userOpen, setUserOpen] = useState(false);

//   const isLoggedIn = localStorage.getItem("auth-token");

//   const logoutHandler = () => {
//     localStorage.removeItem("auth-token");
//     window.location.replace("/");
//   };

//   return (
//     <nav className="navbar">
//       {/* LOGO */}
//       <div className="nav-logo">
//         <img src={logo} alt="logo" />
//         <p>Khan Collections</p>
//       </div>

//       {/* MOBILE HAMBURGER */}
//       <div
//         className="mobile-hamburger"
//         onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//       >
//         <span></span>
//         <span></span>
//         <span></span>
//       </div>

//       {/* MAIN MENU */}
//       <ul className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
//         <li onClick={() => setMenu("shop")} className={menu === "shop" ? "active" : ""}>
//           <Link to="/">Shop</Link>
//           {menu === "shop" && <hr />}
//         </li>

//         <li
//           onMouseEnter={() => setActiveMega("men")}
//           className={menu === "mens" ? "active" : ""}
//           onClick={() => setMenu("mens")}
//         >
//           <div className="menu-wrapper">
//             <Link to="/mens">Men</Link>
//             <MegaMenu mainCategory="men" show={activeMega === "men"} />
//           </div>
//         </li>

//         <li
//           onMouseEnter={() => setActiveMega("women")}
//           onMouseLeave={() => setActiveMega(null)}
//           onClick={() => setMenu("womens")}
//         >
//           <div className="menu-wrapper">
//             <Link to="/womens">Women</Link>
//             <MegaMenu mainCategory="women" show={activeMega === "women"} />
//           </div>
//         </li>

//         <li
//           onMouseEnter={() => setActiveMega("kids")}
//           onMouseLeave={() => setActiveMega(null)}
//           onClick={() => setMenu("kids")}
//         >
//           <div className="menu-wrapper">
//             <Link to="/kids">Kids</Link>
//             <MegaMenu mainCategory="kids" show={activeMega === "kids"} />
//           </div>
//         </li>
//       </ul>

//       {/* RIGHT ICONS */}
//       <div className="nav-icons">
//         {/* USER DROPDOWN */}
//         <div
//           className="user-dropdown"
//           onMouseEnter={() => setUserOpen(true)}
//           onMouseLeave={() => setUserOpen(false)}
//           onClick={() => setUserOpen(!userOpen)}
//         >
//           <img src={user_icon} alt="user" className="user-icon" />

//           {userOpen && (
//             <div className="user-menu">
//               {!isLoggedIn && (
//                 <Link to="/login">Login</Link>
//               )}

//               {isLoggedIn && (
//                 <>
//                   <Link to="/my-orders">My Orders</Link>
//                   <button onClick={logoutHandler}>Logout</button>
//                 </>
//               )}
//             </div>
//           )}
//         </div>

//         {/* CART */}
//         <Link to="/cart" className="cart-icon">
//           <img src={cart_icon} alt="cart" />
//           <span className="nav-cart-count">{getTotalCartItems()}</span>
//         </Link>
//       </div>
//     </nav>
//   );
// };
// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import "./navbar.css";
// import MegaMenu from "../Megamenu/MegaMenu";
// import logo from "../Assets/Frontend_Assets/logo.png";
// import cart_icon from "../Assets/Frontend_Assets/cart_icon.png";
// import user_icon from "../Assets/Frontend_Assets/people.png";
// import { ShopContext } from "../../Context/ShopContext";

// export const Navbar = () => {
//   const { getTotalCartItems } = useContext(ShopContext);

//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [activeMega, setActiveMega] = useState(null);
//   const [mobileMega, setMobileMega] = useState(null);
//   const [userOpen, setUserOpen] = useState(false);

//   const isLoggedIn = localStorage.getItem("auth-token");

//   const logoutHandler = () => {
//     localStorage.removeItem("auth-token");
//     window.location.replace("/");
//   };

//   const isMobile = window.innerWidth <= 991;

//   return (
//     <nav className="navbar">
//       {/* LOGO */}
//       <div className="nav-logo">
//         <img src={logo} alt="logo" />
//         <p>Khan Collections</p>
//       </div>

    

//       {/* MENU */}
//       <ul className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
//         <li>
//           <Link to="/">Shop</Link>
//         </li>

//         {/* MEN */}
//         <li
//           onMouseEnter={() => !isMobile && setActiveMega("men")}
//           // onMouseLeave={() => !isMobile && setActiveMega(null)}
//         >
//           <div className="mobile-menu-title">
//             <Link to="/mens">Men</Link>
//             {isMobile && (
//               <span
//                 className="plus-icon"
//                 onClick={() =>
//                   setMobileMega(mobileMega === "men" ? null : "men")
//                 }
//               >
//                 {mobileMega === "men" ? "−" : "+"}
//               </span>
//             )}
//           </div>

//           <MegaMenu
//             mainCategory="men"
//             show={isMobile ? mobileMega === "men" : activeMega === "men"}
//             mobile={isMobile}
//           />
//         </li>

//         {/* WOMEN */}
//         <li
//           onMouseEnter={() => !isMobile && setActiveMega("women")}
//           onMouseLeave={() => !isMobile && setActiveMega(null)}
//         >
//           <div className="mobile-menu-title">
//             <Link to="/womens">Women</Link>
//             {isMobile && (
//               <span
//                 className="plus-icon"
//                 onClick={() =>
//                   setMobileMega(mobileMega === "women" ? null : "women")
//                 }
//               >
//                 {mobileMega === "women" ? "−" : "+"}
//               </span>
//             )}
//           </div>

//           <MegaMenu
//             mainCategory="women"
//             show={isMobile ? mobileMega === "women" : activeMega === "women"}
//             mobile={isMobile}
//           />
//         </li>

//         {/* KIDS */}
//         <li
//           onMouseEnter={() => !isMobile && setActiveMega("kids")}
//           onMouseLeave={() => !isMobile && setActiveMega(null)}
//         >
//           <div className="mobile-menu-title">
//             <Link to="/kids">Kids</Link>
//             {isMobile && (
//               <span
//                 className="plus-icon"
//                 onClick={() =>
//                   setMobileMega(mobileMega === "kids" ? null : "kids")
//                 }
//               >
//                 {mobileMega === "kids" ? "−" : "+"}
//               </span>
//             )}
//           </div>

//           <MegaMenu
//             mainCategory="kids"
//             show={isMobile ? mobileMega === "kids" : activeMega === "kids"}
//             mobile={isMobile}
//           />
//         </li>
//       </ul>
//         <div className="hambicon">
//         {/* RIGHT ICONS */}
//         <div className="nav-icons">
//           {/* USER */}
//           <div
//             className="user-dropdown"
//             onMouseEnter={() => setUserOpen(true)}
//             onMouseLeave={() => setUserOpen(false)}
//             onClick={() => setUserOpen(!userOpen)}
//           >
//             <img src={user_icon} alt="user" className="user-icon" />

//             <div className={`user-menu ${userOpen ? "show" : ""}`}>
//               {!isLoggedIn && <Link to="/login">Login</Link>}
//               {isLoggedIn && (
//                 <>
//                   <Link to="/my-orders">My Orders</Link>
//                   <button onClick={logoutHandler}>Logout</button>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* CART */}
//           <Link to="/cart" className="cart-icon">
//             <img src={cart_icon} alt="cart" />
//             <span className="nav-cart-count">{getTotalCartItems()}</span>
//           </Link>
//         </div>
//           {/* HAMBURGER */}
//         <div
//           className="mobile-hamburger"
//           onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </div>
//       </div>
//     </nav>
//   );
// };
// import React, { useContext, useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
// import "./navbar.css";
// import MegaMenu from "../Megamenu/MegaMenu";
// import logo from "../Assets/Frontend_Assets/logo.webp";
// import cart_icon from "../Assets/Frontend_Assets/cart_icon.png";
// import user_icon from "../Assets/Frontend_Assets/people.png";
// import { ShopContext } from "../../Context/ShopContext";

// export const Navbar = () => {
//   const { getTotalCartItems } = useContext(ShopContext);

//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [activeMega, setActiveMega] = useState(null);
//   const [mobileMega, setMobileMega] = useState(null);
//   const [userOpen, setUserOpen] = useState(false);

//   const isLoggedIn = localStorage.getItem("auth-token");
//   const isMobile = window.innerWidth <= 991;

//   const logoutHandler = () => {
//     localStorage.removeItem("auth-token");
//     window.location.replace("/");
//   };

//   /* Prevent background scroll when menu open */
//   useEffect(() => {
//     document.body.style.overflow = mobileMenuOpen ? "hidden" : "auto";
//   }, [mobileMenuOpen]);

//   return (
//     <nav className="navbar">
//       {/* LOGO */}
//      <div className="nav-logo">
//           <NavLink to="/" className="logo-link">
//             <img src={logo} alt="Khan Collections" />
//           </NavLink>
//         </div>
    

//       {/* MENU */}
//       <ul className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
//         {/* SHOP */}
//         <li>
//           <NavLink to="/" end className="nav-link">
//             Shop
//           </NavLink>
//         </li>

//         {/* MEN */}
//         <li className="nav-item-with-mega"
//           onMouseEnter={() => !isMobile && setActiveMega("men")}
//          onMouseLeave={() => !isMobile && setActiveMega(null)}
//         >
//           <div className="mobile-menu-title">
//             <NavLink to="/men" className="nav-link">
//               Men
//             </NavLink>

//             {isMobile && (
//               <span
//                 className="plus-icon"
//                 onClick={() =>
//                   setMobileMega(mobileMega === "men" ? null : "men")
//                 }
//               >
//                 {mobileMega === "men" ? "−" : "+"}
//               </span>
//             )}
//           </div>

//           <MegaMenu
//             mainCategory="men"
//             show={isMobile ? mobileMega === "men" : activeMega === "men"}
//             mobile={isMobile}
//               onClose={() => {
//     setMobileMenuOpen(false);
//     setMobileMega(null);}}
//           />
//         </li>

//         {/* WOMEN */}
//         <li className="nav-item-with-mega"
//           onMouseEnter={() => !isMobile && setActiveMega("women")}
//           onMouseLeave={() => !isMobile && setActiveMega(null)}
//         >
//           <div className="mobile-menu-title">
//             <NavLink to="/women" className="nav-link">
//               Women
//             </NavLink>

//             {isMobile && (
//               <span
//                 className="plus-icon"
//                 onClick={() =>
//                   setMobileMega(mobileMega === "women" ? null : "women")
//                 }
//               >
//                 {mobileMega === "women" ? "−" : "+"}
//               </span>
//             )}
//           </div>

//           <MegaMenu
//             mainCategory="women"
//             show={isMobile ? mobileMega === "women" : activeMega === "women"}
//             mobile={isMobile}
//               onClose={() => {
//     setMobileMenuOpen(false);
//     setMobileMega(null);}}
//           />
//         </li>

//         {/* KIDS */}
//         <li className="nav-item-with-mega"
//           onMouseEnter={() => !isMobile && setActiveMega("kids")}
//           onMouseLeave={() => !isMobile && setActiveMega(null)}
//         >
//           <div className="mobile-menu-title">
//             <NavLink to="/kids" className="nav-link">
//               Kids
//             </NavLink>

//             {isMobile && (
//               <span
//                 className="plus-icon"
//                 onClick={() =>
//                   setMobileMega(mobileMega === "kids" ? null : "kids")
//                 }
//               >
//                 {mobileMega === "kids" ? "−" : "+"}
//               </span>
//             )}
//           </div>

//           <MegaMenu
//             mainCategory="kids"
//             show={isMobile ? mobileMega === "kids" : activeMega === "kids"}
//             mobile={isMobile}
//               onClose={() => {
//     setMobileMenuOpen(false);
//     setMobileMega(null);}}
//           />
//         </li>
//       </ul>

//       {/* RIGHT SIDE */}
//       <div className="hambicon">
//         <div className="nav-icons">
//           {/* USER */}
//           <div
//             className="user-dropdown"
//             onMouseEnter={() => setUserOpen(true)}
//             onMouseLeave={() => setUserOpen(false)}
//             onClick={() => setUserOpen(!userOpen)}
//           >
//             <img src={user_icon} alt="user" className="user-icon" />

//             <div className={`user-menu ${userOpen ? "show" : ""}`}>
//               {!isLoggedIn && <NavLink to="/login">Login</NavLink>}

//               {isLoggedIn && (
//                 <>
//                   <NavLink to="/my-orders">My Orders</NavLink>
//                   <button onClick={logoutHandler}>Logout</button>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* CART */}
//           <NavLink to="/cart" className="cart-icon">
//             <img src={cart_icon} alt="cart" />
//             <span className="nav-cart-count">{getTotalCartItems()}</span>
//           </NavLink>
//         </div>

//         {/* HAMBURGER */}
//         <div
//           className="mobile-hamburger"
//           onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </div>
//       </div>
//     </nav>
//   );
// };
import React, { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./navbar.css";
import MegaMenu from "../Megamenu/MegaMenu";
import logo from "../Assets/Frontend_Assets/LOGODONE.png";
import cart_icon from "../Assets/Frontend_Assets/cart_icon.png";
import user_icon from "../Assets/Frontend_Assets/people.png";
import { ShopContext } from "../../Context/ShopContext";

export const Navbar = () => {
  const { getTotalCartItems } = useContext(ShopContext);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMega, setActiveMega] = useState(null); // Desktop hover
  const [mobileMega, setMobileMega] = useState(null); // Mobile toggle
  const [userOpen, setUserOpen] = useState(false);

  const isLoggedIn = localStorage.getItem("auth-token");
  const isMobile = window.innerWidth <= 991;

  const logoutHandler = () => {
    localStorage.removeItem("auth-token");
    window.location.replace("/");
  };

  /* Prevent background scroll when menu open */
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "auto";
  }, [mobileMenuOpen]);

  /* Close mobile menu when window resized to desktop */
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setMobileMenuOpen(false);
        setMobileMega(null);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* Helper to handle link click in mobile */
  const handleMobileLinkClick = () => {
    if (isMobile) {
      setMobileMenuOpen(false);
      setMobileMega(null);
    }
  };

  return (
    <nav className="navbar">
      {/* LOGO */}
      <div className="nav-logo">
        <NavLink to="/" className="logo-link" onClick={handleMobileLinkClick}>
          <img src={logo} alt="Khan Collections" />
        </NavLink>
      </div>

      {/* MENU */}
      <ul className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
        {/* SHOP */}
        <li>
          <NavLink to="/" end className="nav-link" onClick={handleMobileLinkClick}>
            Shop
          </NavLink>
        </li>

        {/* MEN */}
        <li
          className="nav-item-with-mega"
          onMouseEnter={() => !isMobile && setActiveMega("men")}
          onMouseLeave={() => !isMobile && setActiveMega(null)}
        >
          <div className="mobile-menu-title">
            <NavLink
              to="/men"
              className="nav-link"
              onClick={handleMobileLinkClick}
            >
              Men
            </NavLink>

            {isMobile && (
              <span
                className="plus-icon"
                onClick={() =>
                  setMobileMega(mobileMega === "men" ? null : "men")
                }
              >
                {mobileMega === "men" ? "−" : "+"}
              </span>
            )}
          </div>

          <MegaMenu
            mainCategory="men"
            show={isMobile ? mobileMega === "men" : activeMega === "men"}
            mobile={isMobile}
            onClose={() => setMobileMega(null)}
          />
        </li>

        {/* WOMEN */}
        <li
          className="nav-item-with-mega"
          onMouseEnter={() => !isMobile && setActiveMega("women")}
          onMouseLeave={() => !isMobile && setActiveMega(null)}
        >
          <div className="mobile-menu-title">
            <NavLink
              to="/women"
              className="nav-link"
              onClick={handleMobileLinkClick}
            >
              Women
            </NavLink>

            {isMobile && (
              <span
                className="plus-icon"
                onClick={() =>
                  setMobileMega(mobileMega === "women" ? null : "women")
                }
              >
                {mobileMega === "women" ? "−" : "+"}
              </span>
            )}
          </div>

          <MegaMenu
            mainCategory="women"
            show={isMobile ? mobileMega === "women" : activeMega === "women"}
            mobile={isMobile}
            onClose={() => setMobileMega(null)}
          />
        </li>

        {/* KIDS */}
        <li
          className="nav-item-with-mega d-none"
          onMouseEnter={() => !isMobile && setActiveMega("kids")}
          onMouseLeave={() => !isMobile && setActiveMega(null)}
        >
          <div className="mobile-menu-title">
            <NavLink
              to="/kids"
              className="nav-link"
              onClick={handleMobileLinkClick}
            >
              Kids
            </NavLink>

            {isMobile && (
              <span
                className="plus-icon"
                onClick={() =>
                  setMobileMega(mobileMega === "kids" ? null : "kids")
                }
              >
                {mobileMega === "kids" ? "−" : "+"}
              </span>
            )}
          </div>

          <MegaMenu
            mainCategory="kids"
            show={isMobile ? mobileMega === "kids" : activeMega === "kids"}
            mobile={isMobile}
            onClose={() => setMobileMega(null)}
          />
        </li>
      </ul>

      {/* RIGHT SIDE */}
      <div className="hambicon">
        <div className="nav-icons">
          {/* USER */}
          <div
            className="user-dropdown"
            onMouseEnter={() => setUserOpen(true)}
            onMouseLeave={() => setUserOpen(false)}
            onClick={() => setUserOpen(!userOpen)}
          >
            <img src={user_icon} alt="user" className="user-icon" />

            <div className={`user-menu ${userOpen ? "show" : ""}`}>
              {!isLoggedIn && <NavLink to="/login">Login</NavLink>}

              {isLoggedIn && (
                <>
                  <NavLink to="/my-orders">My Orders</NavLink>
                  <button onClick={logoutHandler}>Logout</button>
                </>
              )}
            </div>
          </div>

          {/* CART */}
          <NavLink to="/cart" className="cart-icon">
            <img src={cart_icon} alt="cart" />
            <span className="nav-cart-count">{getTotalCartItems()}</span>
          </NavLink>
        </div>

        {/* HAMBURGER */}
        <div
          className="mobile-hamburger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
